<ng-container *ngIf="!isLoading; else shimmer">
  <h3 class="title" *ngIf="isEmbedded">
    <a *ngIf="!isChallenge" routerLink="/cards/take-action" class="header-link">
      <span>Take Action</span>
      <svg-icon src="assets/icons/chevron-right-nocircle.svg"></svg-icon>
    </a>
  </h3>
  <h3 *ngIf="isChallenge" class="title">My Actions</h3>

  <div class="checklist-cards-wrap">
    <!-- Adding comment to remove extra space that Prettier adds around the link and before the period -->
    <!-- prettier-ignore -->
    <p *ngIf="noCards; else widget" class="no-cards-message">
      Here you'll track
      <ng-container *ngIf="!isChallenge">Quests and Actions you've committed to. Go to
        <a routerLink="/discover" [queryParams]="{ resetSearch: true }">Discover</a>
        to find things you'd like to try! </ng-container>
      <ng-container *ngIf="isChallenge">actions you've committed to that count for this Challenge. Find ones you'd like to try below or on
        <a routerLink="/discover" [queryParams]="{ resetSearch: true }">Discover</a>!</ng-container>
    </p>
  </div>

  <ng-template #widget>
    <kp-card-category
      *ngFor="let collection of cardCollections; let index = index"
      [cardCollection]="collection"
      [collectionIndex]="index"
      [cardDisplayType]="cardDisplayType.checklist"
      [customCardCategory]="customCardCategory"
      [requestType]="cardRequestType.TAKE_ACTION"
      [screen]="cardScreen"></kp-card-category>
    <a class="view-all-link" routerLink="/cards/take-action" *ngIf="showViewAll">
      <span>View All</span>
      <svg-icon src="assets/icons/chevron-right-nocircle.svg"></svg-icon>
    </a>
  </ng-template>
</ng-container>

<ng-template #shimmer>
  <kp-shimmer class="take-action-shimmer"></kp-shimmer>
</ng-template>
